import React from 'react';
import { reactUrlToBrowserUrl } from '../../../../urlParse';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';
import { ProductCarouselModel } from '../Basepage/parts/ProductCarousel/Model';
import Banner from './Parts/Banner';
import BestsellerViewer from '../Basepage/parts/BestsellerViewer';

import iconMedizin from './Parts/Images/icon-medizin.svg';
import iconSport from './Parts/Images/icon-sport.svg';
import iconVersand from './Parts/Images/icon-versand.svg';
import bigBanner from './Parts/Images/buchbutler_barsortiment_on_demand.jpg';

import './index.scss';

interface StartPageState extends BasePageState {}

interface StartPageModel {
  bannerConfig: any;
  features: any;
  spiegel_HCBelle: ProductCarouselModel[];
  spiegel_HoerbuchKinder: ProductCarouselModel[];
}

export default class StartPage extends Basepage<
  StartPageState,
  StartPageModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="startPage">
        <Banner config={this.body.bannerConfig} />
        {/* TODO:Check Text */}
        {/* 
        <div id="mitteContainer">
          <div className="horizontalSplit">
            <div className="kahel">
              <span className="titile">Werbeseiten</span>
              <span className="subTitile">Exporte</span>
              
              Sie wollen unsere Daten/Angebot/Artikel in Ihr System integrieren,
              sprechen Sie uns an.
              <br />
              Wir stellen Ihnen gerne individuelle Schnittstellen zur Verfügung,
              passend zu Ihrem Warenwirtschaftszstem oder ERP System. <br />
              Ihr System benötigt die Daten soundso, wie liefern die Daten, wie
              ihr System es braucht
              <br />
              <a href="mailto:service@buchbutler.de">Kontakt aufnehmen</a>
            </div>
          </div>

          <div className="horizontalSplit">
            <div>
              <div className="kahel">
                <span className="titile">Medizin</span>
                30.000 Fachbücher
                <br />
                <img src={iconMedizin} style={{ height: '100px' }} />
              </div>
              <div className="kahel">
                <img src={iconSport} style={{ height: '100px' }} />
                <br />
                50.000 Artikel zum Thema
                <span className="titile">Sport</span>
              </div>
            </div>
          </div>

          <div className="kahel">
            <div>
              <span className="titile">Versand</span>
              schnell und sicher
              <br />
              <MolLink to="/logistik" href="/logistik">
                Mehr Erfahren
              </MolLink>
            </div>
            <img src={iconVersand} style={{ height: '100px' }} />
          </div>
          
        </div>
        */}
        <MolLink to="/kontakt" href="/kontakt">
          <img
            src={bigBanner}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
            }}
          />
        </MolLink>
        <MolLink to="/howToStart" href="/howToStart">
          <div id="imgHowToStart" />
        </MolLink>
        <MolLink to="/faq" href="/faq">
          <div id="imgFAQ" />
        </MolLink>

        <div className="bestsellerContainer">
          <div className="bestsellerWrapper">
            <BestsellerViewer
              items={this.body.spiegel_HCBelle}
              hasCookie={this.state.hasCookie}
              title="Spiegel-Bestseller"
              allLink="/search_page/?fqZZZListe=Spiegel+Bestseller+Hardcover+Belletristik"
            ></BestsellerViewer>
          </div>
        </div>
      </div>
    );
  }

  initState(base: BasePageState): StartPageState {
    let newState: StartPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/StartPage.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}

  initJSChild(): string {
    let initjs = '';

    return initjs;
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string {
    return '';
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Startpage</span>;
  }
  getType(): string {
    return 'StartPage';
  }
}
